"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndReviewsHeader = void 0;
var RatingsAndReviewsHeader_1 = require("./RatingsAndReviewsHeader");
Object.defineProperty(exports, "RatingsAndReviewsHeader", { enumerable: true, get: function () { return RatingsAndReviewsHeader_1.RatingsAndReviewsHeader; } });
//# sourceMappingURL=index.js.map